import { styled } from '@mui/material/styles';
import { Dialog, DialogContent } from '@mui/material';

import BasicDialogHeader from './BasicDialogHeader';
import { useAppSelector } from '../../hooks/useAppSelector';
import { useTranslation } from 'react-i18next';
import Drivers from '../home/drivers/Drivers';
import * as providerSlice from '../../data/provider.slice';
import { Provider } from '../../data/models/provider.model';

const PREFIX = 'OnboardDriversDialog';

const classes = {
  content: `${PREFIX}-content`,
};

const RootDialog = styled(Dialog)(() => ({
  [`& .${classes.content}`]: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
  },
}));

interface OnboardDriversDialogProps {
  open: boolean;
  close: () => void;
}

export default function OnboardDriversDialog({
  open,
  close,
}: OnboardDriversDialogProps) {
  const { t } = useTranslation('common');
  const provider = useAppSelector(providerSlice.selectProvider) as Provider;

  const handleClose = () => {
    close();
  };

  return (
    <RootDialog fullScreen open={open} onClose={handleClose}>
      <BasicDialogHeader title={t('onboard.drivers')} close={close} />
      <DialogContent className={classes.content}>
        <Drivers provider={provider} canCreate />
      </DialogContent>
    </RootDialog>
  );
}
